<template>
<DxDataGrid :columns="dataColumns" :data-source="dataItemsSource" ref="gridComponent"
	:allowColumnReordering="true" :allowColumnResizing="true" height="95%"
	:show-row-lines="!!props.settings.showRowLines" :show-column-lines="!!props.settings.showColLines" :show-borders="!!props.settings.showBorders" :row-alternation-enabled="!!props.settings.showZebra" :hover-state-enabled="!!props.settings.useHoverRowState"
	:class="props.settings.useSimpleClick ? 'datagrid-use-pointer' : ''"
	@row-expanding="onRowExpanding" @option-changed="onOptionChanged" @context-menu-preparing="onContextMenuPreparing" @content-ready="onContentReady" @row-dbl-click="onRowDblClick" @row-click="onRowClick" @row-prepared="onRowPrepared">
	<dx-column-chooser :enabled="!!props.settings.showColumnChooser" mode="select" :searchEnabled="true" height="400px">
		<dx-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button" />
	</dx-column-chooser>
	<dx-toolbar>
		<dx-item location="before" name="headingText" :text="String(props.settings.heading ? props.settings.heading : '')" />
		<dx-item location="before" name="toggleImportData" widget="dxButton" :options="viewImportsButtonOptions" />
		<dx-item location="before" name="searchPanel" :visible="!!props.settings.showSearch" />
		<dx-item location="before" name="groupPanel" />
		<dx-item location="after" name="addRowButton" />
		<dx-item location="after" name="importButton" widget="dxButton" :options="importButtonOptions" :visible="!props.settings.disallowImport"/>
		<dx-item location="after" name="columnChooserButton" />
	</dx-toolbar>
	<dx-filter-row :visible="props.settings.showFilterRow === true" />
	<dx-header-filter :visible="props.settings.showHeaderFilter === true" />
	<dx-search-panel :visible="true" width="300px" />
	<dx-master-detail :enabled="props.settings.showMasterDetail" template="masterDetailTemplate"  />
	<dx-editing :mode="props.settings.editingMode ? props.settings.editingMode : 'row'"
		:allow-updating="props.settings.editingMode !== 'none'"
		:allow-deleting="props.settings.editingMode !== 'none' && props.settings.disallowDeleting !== true"
		:allow-adding="props.settings.editingMode !== 'none' && props.settings.disallowAdding !== true"
	>
		<DxDGForm :col-count="2" label-mode="floating">
			<template v-for="fieldCol in dataColumns" :key="fieldCol.key">
				<DxItem v-if="fieldCol['_field']" item-type="simple" :data-field="fieldCol.dataField" :editor-type="fieldCol.editorFormType ?? fieldCol.editorType" :editor-options="fieldCol.editorFormOptions ?? fieldCol.editorOptions" />
				<DxItem v-if="!fieldCol['_field']" item-type="empty" :col-span="2" />
				<DxItem v-if="!fieldCol['_field']" item-type="group" :col-span="2" :col-count="2" :caption="fieldCol.caption ? fieldCol.caption : undefined" css-class="datagrid-editor-group">
					<DxItem v-for="subfieldCol in fieldCol.columns.filter(c => c['_field'])" :key="fieldCol.key + '-' + subfieldCol.key" :data-field="subfieldCol.dataField" :editor-type="subfieldCol.editorType" :editor-options="subfieldCol.editorOptions" />
				</DxItem>
			</template>
		</DxDGForm>
	</dx-editing>
	<DxGroupPanel v-if="props.settings.useGrouping === true" :visible="true" :allow-column-dragging="false" />
	<DxGrouping v-if="props.settings.useGrouping === true" :autoExpandAll="false" :contextMenuEnabled="true" />
	<DxSummary>
		<DxTotalItem column="last_count" :summary-type="props.settings.aggregates ? props.settings.aggregates : 'sum'" v-if="props.settings.useAggregates === true" />
		<DxGroupItem column="last_count" :summary-type="props.settings.aggregates ? props.settings.aggregates : 'sum'" v-if="props.settings.useGrouping === true && props.settings.showGroupAggregates === true" />
	</DxSummary>
	<dx-paging :enabled="true" />
	<template #masterDetailTemplate="{ data }">
		<DxTabPanel iconPosition="left">
			<DxItem v-if="!Array.isArray(props.settings.masterDetailTabs) || props.settings.masterDetailTabs.length == 0" title="No tabs configured" icon="warning">
				<div class="master-detail-tabpanel-item">
					No tabs are configured for this master detail display.
				</div>
			</DxItem>
			<DxItem v-else v-for="tab in props.settings.masterDetailTabs" :key="tab.id" :title="tab.label" :icon="tab.icon">
				<template v-if="tab.type == 'datagrid'">
					<DxMdtSubgrid :preview="props.preview" :settings="props.settings" :context="props.context" :tab="tab" :parent-row="data.data" />
				</template>
				<template v-if="tab.type == 'list'">
				<DxList :data-source="paymentsList">
					<template #item="{ data }">
						<div style="display: flex; align-items: center; padding: 10px;">
							<i :class="'dx-icon-' + data.icon" style="font-size: 24px; margin-right: 15px; color: var(--dx-color-icon);"></i>
							<div style="flex-grow: 1;">
								<div style="font-weight: 500;">{{ data.description }}</div>
								<div style="color: var(--dx-color-text-muted); font-size: 0.9em;">
									{{ new Date(data.date).toLocaleDateString() }}
								</div>
							</div>
							<div :style="{ color: data.amount > 0 ? 'var(--dx-color-success)' : 'var(--dx-color-danger)', fontWeight: '500' }">
								{{ data.amount > 0 ? '+' : '' }}{{ data.amount.toLocaleString('en-US', {style: 'currency', currency: 'USD'}) }}
							</div>
						</div>
					</template>
				</DxList>
				</template>
				<template v-else-if="tab.type == 'itemview'">
					<UxItemview :data-source="dataItemsSource" />
				</template>
				<template v-else-if="tab.type == 'editor'">
				<div style="padding: 20px;">
					<div style="font-size:1.2em;font-weight:bold;margin:1em 0;border-bottom:1px solid #ccc;padding-bottom:0.5em;">Create new inventory item transaction</div>
					<DxForm label-mode="floating">
						<DxSimpleItem data-field="employee" editor-type="dxTextBox">
							<DxLabel text="Employee Name" />
						</DxSimpleItem>
						<DxSimpleItem data-field="sku" editor-type="dxTextBox">
							<DxLabel text="SKU" />
						</DxSimpleItem>
						<DxSimpleItem data-field="warehouse" editor-type="dxSelectBox">
							<DxLabel text="Warehouse" />
						</DxSimpleItem>
						<DxSimpleItem data-field="transport_cost" editor-type="dxNumberBox">
							<DxLabel text="Transport Cost" />
						</DxSimpleItem>
						<DxSimpleItem data-field="quantity" editor-type="dxNumberBox">
							<DxLabel text="Quantity" />
						</DxSimpleItem>
						<DxSimpleItem data-field="description" editor-type="dxTextArea">
							<DxLabel text="Description / Notes" />
						</DxSimpleItem>
						<DxButtonItem :button-options="{ icon: 'add', text: 'Create transaction', type: 'success' }" horizontal-alignment="right" />
					</DxForm>
				</div>
				</template>
				<template v-else-if="tab.type == 'drive'">
					<UxDrive />
				</template>
				<template v-else-if="tab.type == 'comments'">
					<DxList :data-source="commentsList">
						<template #item="{ data }">
							<div style="display: flex; gap: 12px; padding: 12px 0; border-bottom: 1px solid var(--dx-color-border);">
								<div style="width: 40px; height: 40px; border-radius: 50%; background: var(--dx-color-icon); display: flex; align-items: center; justify-content: center;">
									<i class="dx-icon-user" style="color: white;"></i>
								</div>
								<div style="flex-grow: 1;">
									<div style="display: flex; justify-content: space-between;">
										<span style="font-weight: 500;">{{ data.user }}</span>
										<span style="color: var(--dx-color-text-muted); font-size: 0.9em;">
											{{ new Date(data.date).toLocaleDateString() }}
										</span>
									</div>
									<div style="margin-top: 4px;">{{ data.comment }}</div>
								</div>
							</div>
						</template>
					</DxList>
				</template>
			</DxItem>
		</DxTabPanel>
	</template>
	<template #columnFileEdit="{ data }">
		<div :class="data.cellElement !== null ? '' : 'dx-card'">
			<div v-if="data.cellElement === null" class="dx-card-title">{{ data.column.caption }}</div>
			<div v-if="data.cellElement === null" style="height:10px;"></div>
			<DxFileUploader upload-mode="instantly" :upload-url="appInfo.baseURL + '/attachment'" :upload-headers="{ 'accept': 'application/json' }"
				@uploaded="onFileUploaded(data, $event)" @value-changed="onFileValueChanged(data, $event)" :value="data.value && data.value.id ? [{ name: data.value.filename, size: data.value.filesize }] : []"
			/>
		</div>
	</template>
	<template #columnFileRender="{ data }">
		<a v-if="data.value && data.value.store" :href="appInfo.storageURL + '/' + data.value.store" target="_blank">{{ data.text }}</a>
	</template>
	<template #columnReferenceEdit="{ data }">
		<ReferenceSelector :relationship-details="data.column['_relationshipDetails']" :label="data.column.caption" :is-row-editor="data.cellElement !== null"
			:existing="data.value" @updated="onReferenceValueChanged(data, $event)" />
	</template>
	<template #columnReferenceRender="{ data }">
		<template v-if="data.value && Array.isArray(data.value)">
			<a class="reference-link" v-for="item in data.value" :key="item.id" href="#" @click.prevent.stop="onReferenceClicked(item)">{{ item.name || item.title || item.code || ('#' + item.id) }}</a>
		</template>
		<template v-else>
			<span></span>
		</template>
	</template>
	
</DxDataGrid>
<DxPopup v-model:visible="showImportWizard" :show-title="true" :show-close-button="true" width="80%" height="80%" title="Import Wizard">
	<ImportWizard :context="props.context" :component-settings="props.settings" @completed="onImportCompleted" />
</DxPopup>
</template>

<script setup>
/* eslint-disable */

import DxDataGrid, { DxItem, DxSearchPanel, DxFilterRow, DxColumnChooser, DxPosition, DxHeaderFilter, DxToolbar, DxMasterDetail, DxEditing, DxPaging, DxColumn, DxGroupPanel, DxGrouping, DxSummary, DxTotalItem, DxGroupItem, DxButton, DxForm as DxDGForm } from "devextreme-vue/data-grid";
import DxTabPanel from 'devextreme-vue/tab-panel';
import { defineProps, watch, ref, defineEmits, inject, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import DataSource from "devextreme/data/data_source"
import UxItemview from './ux-itemview';
import DxList from 'devextreme-vue/list';
import UxDrive from './ux-drive';
import DxForm, { DxSimpleItem, DxLabel, DxButtonItem } from 'devextreme-vue/form';
import DxFileUploader from 'devextreme-vue/file-uploader';
import DxPopup from 'devextreme-vue/popup';
import { fieldNamesReserved, stripFileFieldData } from '@/fields';
import { SchemaCache, getDatagridColumnsFromSchema } from "@/schemas.js";
import DxMdtSubgrid from './ux-mdt-subgrid';
import { alert as dxAlert } from 'devextreme/ui/dialog';
import ReferenceSelector from '@/components/reference-selector';
import ImportWizard from '@/components/import-wizard';
import appInfo from '@/app-info';
// import { Mote } from '@/mote';

import { useUxActions } from '@/composables/useActions';
const { generateContextMenuFromActions, executeWithContext } = useUxActions();

const paymentsList = [
	{ id: 1, date: '2024-01-15', description: 'Invoice Payment #1234', amount: 1250.00, icon: 'check' },
	{ id: 2, date: '2024-01-14', description: 'Refund - Order #5678', amount: -125.50, icon: 'undo' },
	{ id: 3, date: '2024-01-13', description: 'Service Payment #9012', amount: 750.00, icon: 'check' },
	{ id: 4, date: '2024-01-12', description: 'Monthly Subscription', amount: 299.99, icon: 'check' },
	{ id: 5, date: '2024-01-11', description: 'Credit Card Payment', amount: 1875.25, icon: 'check' }
];
const commentsList = [
	{ id: 1, user: 'John Doe', date: '2024-01-20', comment: 'Updated inventory count after quarterly audit.' },
	{ id: 2, user: 'Jane Smith', date: '2024-01-19', comment: 'Noted discrepancy in shipping manifest #1234.' },
	{ id: 3, user: 'Mike Johnson', date: '2024-01-18', comment: 'Completed quality check on recent shipment.' },
	{ id: 4, user: 'Sarah Wilson', date: '2024-01-17', comment: 'Scheduled maintenance for next week.' },
	{ id: 5, user: 'Tom Brown', date: '2024-01-16', comment: 'Updated supplier contact information.' },
	{ id: 6, user: 'Emily Davis', date: '2024-01-15', comment: 'Processed refund request for order #5678.' },
	{ id: 7, user: 'Alex Turner', date: '2024-01-14', comment: 'Implemented new safety protocols in warehouse.' },
	{ id: 8, user: 'Rachel Green', date: '2024-01-13', comment: 'Updated customer delivery preferences.' },
	{ id: 9, user: 'David Chen', date: '2024-01-12', comment: 'Resolved inventory synchronization issue.' },
	{ id: 10, user: 'Lisa Wong', date: '2024-01-11', comment: 'Completed staff training on new equipment.' },
	{ id: 11, user: 'Mark Taylor', date: '2024-01-10', comment: 'Reviewed and approved vendor contracts.' },
	{ id: 12, user: 'Sophie Martin', date: '2024-01-09', comment: 'Organized warehouse layout optimization.' },
	{ id: 13, user: 'Chris Anderson', date: '2024-01-08', comment: 'Updated shipping rates for Q1 2024.' },
	{ id: 14, user: 'Amanda White', date: '2024-01-07', comment: 'Conducted monthly safety inspection.' },
	{ id: 15, user: 'Kevin Park', date: '2024-01-06', comment: 'Implemented new quality control measures.' },
	{ id: 16, user: 'Nicole Adams', date: '2024-01-05', comment: 'Coordinated with suppliers for rush order.' },
	{ id: 17, user: 'Ryan Murphy', date: '2024-01-04', comment: 'Updated emergency response procedures.' },
	{ id: 18, user: 'Jessica Lee', date: '2024-01-03', comment: 'Reconciled inventory discrepancies.' },
	{ id: 19, user: 'Brian Wilson', date: '2024-01-02', comment: 'Set up new tracking system for returns.' },
	{ id: 20, user: 'Michelle Rodriguez', date: '2024-01-01', comment: 'Prepared end-of-year inventory report.' },
	{ id: 21, user: 'Peter Zhang', date: '2023-12-31', comment: 'Implemented new storage organization system.' },
	{ id: 22, user: 'Karen Thompson', date: '2023-12-30', comment: 'Updated vendor contact database.' },
	{ id: 23, user: 'George Baker', date: '2023-12-29', comment: 'Completed annual equipment maintenance.' },
	{ id: 24, user: 'Diana Scott', date: '2023-12-28', comment: 'Reviewed and updated shipping policies.' },
	{ id: 25, user: 'James Miller', date: '2023-12-27', comment: 'Organized staff schedule for holiday season.' }
];

const props = defineProps([
	'preview',
	'settings',
	'context',
]);
const emit = defineEmits(['previewOptionsChanged', 'actionEditorAdd', 'actionEditorEdit']);
const $http = inject('$http');
const router = useRouter();
const route = useRoute();

const gridComponent = ref(null);
const dataColumns = ref([]);
const showImportDataItems = ref(false);
const dataItemsSource = new DataSource({
	loadMode: 'raw',
	cacheRawData: true,
	key: 'id',
	load: async (loadOptions) => {
		if (!props.settings || !props.settings.source)
			return [];
		
		let params = { 
			type: props.settings.source, 
			expanded: 1, 
			use_import: (showImportDataItems.value ? 1 : 0) 
		};
		
		// Add contextual filtering if configured and context mote exists
		if (props.settings.sourceContextual && props.context?.context?.id) {
			const relationship = SchemaCache.getByKeyspec(props.settings.sourceContextual);
			const details = relationship?.getRelationshipDetails();
			if (details) {
				params.from = props.context.context.id;
				params.relation_schema = details.relationSchema.type;
			}
		}
		
		let fetchRequest = await $http.get('/mote', { params });
		
		let motes = fetchRequest.data.motes.map(({ payload, ...datum }) => ({
			...(payload || {}),
			...datum
		}));
		
		// Iterate over all motes and replace all our relationship objects with actual related motes.
		let relatedMotes = Object.fromEntries(
			fetchRequest.data.related_motes.map(mote => [mote.id, mote])		// (makes a hashmap of related motes by id)
		);
		
		for (const mote of motes) {
			for (const [fieldKey, fieldValue] of Object.entries(mote)) {
				if (!(fieldValue && Array.isArray(fieldValue) && fieldValue.length > 0 && fieldValue[0].rel_id && fieldValue[0].mote_id))
					continue;
				for (var i = 0; i < fieldValue.length; i++) {
					if (fieldValue[i].mote_id in relatedMotes) {
						const originalObj = fieldValue[i];
						fieldValue[i] = relatedMotes[fieldValue[i].mote_id];
						fieldValue[i] = {
							...(fieldValue[i].payload || {}),
							...fieldValue[i],
							'_expanded': originalObj,
						};
						delete fieldValue[i].payload;
					} else {
						console.warn(`Failed to find related mote for field ${fieldKey} (index ${i}) on mote ${mote.id}. Expected to find mote ${fieldValue[i].mote_id} in related_motes, relationship will be ignored.`);
						fieldValue[i] = null;
					}
				}
				// mote[fieldKey] = fieldValue[0] ? fieldValue[0] : null;
				mote[fieldKey] = fieldValue || null;
				// TODO: Cleanup fieldValue of null values?
				// TODO: Handle limited numbers of related items? Right now we only assume there will always just be 0-1.
			}
		}
		console.log("Fetched datagrid data", motes);
		return motes;
	},
	insert: async (values) => {
		// If the values included an id or any other reserved fields, just silently drop/ignore it.
		for (const key of fieldNamesReserved) {
			if (values[key])
				delete values[key];
		}
		
		const schema = SchemaCache.getSchemaByType(props.settings.source);
		if (!schema) {
			throw new Error('Could not find schema for insert; save aborted!');
		}
		const groupId = props.context?.group_id ?? null;
		if (!groupId || props.preview) {
			throw new Error(!props.context || props.preview ? 'Insert skipped - previewing component' : 'Could not find group for insert; save aborted!');
		}

		// TODO: Deal with schema actions, defaults, etc.
		
		const response = await $http.post('/mote', {
			group_id: groupId,
			type_id: schema.id,
			payload: values,
		});
		return response.data;
	},
	update: async (key, values) => {
		// TODO: This is a hack to get the original item. Once we use the proper non-raw data source, check how this is supposed to properly work!
		const originalItem = dataItemsSource['_items'].find(item => item.id == key);
		if (!originalItem) {
			throw new Error('Could not find original item for update; save aborted!');
		}
		
		const schema = SchemaCache.getSchemaByType(props.settings.source);
		if (!schema) {
			throw new Error('Could not find schema for update; save aborted!');
		}
		const groupId = props.context?.group_id ?? null;
		if (!groupId || props.preview) {
			throw new Error(!props.context || props.preview ? 'Update skipped - previewing component' : 'Could not find group for update; save aborted!');
		}
		// TODO: Deal with schema actions, defaults, etc.
		
		// Create our updated PATCH data, where we include sequence and base fields and put the custom values in payload.
		const patchData = {
			id: key,
			sequence: originalItem.sequence + 1,
			payload: {},
		};
		for (const [key, value] of Object.entries(values)) {
			if (fieldNamesReserved.includes(key))		// Ignore attempted changes to non-field entries.
				continue;
			// TODO: Drop any values that don't resolve to a field we understand on this schema.
			patchData.payload[key] = value;
		}

		const response = await $http.patch(`/mote/${key}`, patchData);
		return response.data;
	},
	remove: async (key) => {
		// TODO: This is a hack to get the original item. Once we use the proper non-raw data source, check how this is supposed to properly work!
		const originalItem = dataItemsSource['_items'].find(item => item.id == key);
		if (!originalItem) {
			throw new Error('Could not find original item for delete; delete aborted!');
		}

		const schema = SchemaCache.getSchemaByType(props.settings.source);
		if (!schema) {
			throw new Error('Could not find schema for delete; delete aborted!');
		}
		const groupId = props.context?.group_id ?? null;
		if (!groupId || props.preview) {
			throw new Error(!props.context || props.preview ? 'Delete skipped - previewing component' : 'Could not find group for delete; delete aborted!');
		}

		const response = await $http.delete(`/mote/${key}`, { data: { sequence: originalItem.sequence } });
		return response.data;
	}
});

const previewColumnChanges = ref({});		// Changes to the column options that are pending when in preview mode.

// Called when a row is expanded to display the master detail template. We automatically collapse any other rows that are expanded.
const onRowExpanding = (e) => {
	e.component.collapseAll(-1);
}

// Called when an editor option (e.g. column width or column visibility) is changed.
const onOptionChanged = (e) => {
	// If we aren't in preview mode, we don't need to do anything since we don't persist settings on user changes.
	if (!props.preview || !props.settings)
		return;
	// Otherwise, we may need to save our updated settings to our parent ux-settings-editor - to persist widths or visibility.
	// We persist the following: columns[n].sortOrder, columns[n].width, columns[n].visible, columns[n].groupIndex
	// We also persist the same for banded columns, i.e.: columns[n].columns[s].sortOrder, etc.
	const savedRegex = /columns\[(\d+)\](?:\.columns\[(\d+)\])?.(sortOrder|width|visible|groupIndex)/;
	if (!savedRegex.test(e.fullName)) {
		return;
	}
	const matches = e.fullName.match(savedRegex);
	const parentIndex = matches[1];
	const childIndex = matches[2];
	const variable = matches[3];

	// The numerical index is passed in, with more than one value for banded columns, but we want to store by the field key instead.
	let fieldKey = null;
	if (childIndex !== undefined) {
		fieldKey = dataColumns.value[parentIndex]?.columns?.[childIndex]?.key;
	} else {
		fieldKey = dataColumns.value[parentIndex]?.key;
	}

	if (!fieldKey) {
		console.error(`Couldn't find field key for column ${parentIndex}${childIndex ? `.${childIndex}` : ''} on options change`);
		return;
	}
	console.log(`Datagrid Preview: Option change noted: ${parentIndex}${childIndex ? `.${childIndex}` : ''},${fieldKey},${variable},${e.value}`);
	
	// Store in our pending changes object, keyed by field key. Changes are only applied when the datagrid is initialized in our props watcher.
	if (!previewColumnChanges.value[fieldKey])
		previewColumnChanges.value[fieldKey] = {};
	previewColumnChanges.value[fieldKey][variable] = e.value;
	// The parent component is responsible for actually displaying that the changes are present and the UX for revert/save, so we emit a hint to render this in preview mode.
	emit('previewOptionsChanged', previewColumnChanges.value);
}

const onContentReady = (e) => {
	// If we have disabled the command buttons, we need to manually override the command column here to be hidden as well.
	if (props.settings.hideEditingCommandColumn) {
		e.component.columnOption("command:edit", "visible", false);  
	}
}

// Shade rows that are flagged as imported
const onRowPrepared = (e) => {
    if (e.rowType === 'data' && e.data && (e.data.imported === true || e.data._imported === true)) {
        e.rowElement.classList.add('dx-row-imported');
    }
}

// Prepare custom context menu items for data rows.
const onContextMenuPreparing = (e) => {
	if (e.row?.rowType !== 'data')
		return;
	e.items = generateContextMenuFromActions(e.row.data, props.preview);
	for (const item of e.items) {
		if (item.actionId == '_new') {
			item.onItemClick = () => {
				emit('actionEditorAdd', { method: 'add', type: 'contextmenu'});
			};
		} else if (item.actionId && props.preview) {
			item.onItemClick = () => {
				emit('actionEditorEdit', { method: 'edit', actionId: item.actionId });
			};
		} else if (item.actionId) {
			item.onItemClick = () => {
				console.log("Action execution requested for item = ", item);
				executeWithContext(item.actionId, { component: 'todo', page: 'todo', mote: e.row.data });
			};
		}
	}
	e.items.unshift(
		{
			text: "Edit Row",
			icon: "edit",
			visible: props.settings.editingMode !== 'none',
			onItemClick: () => {
				gridComponent.value.instance.editRow(e.row.rowIndex);
			}
		},
		{
			text: "Delete Row",
			icon: "trash",
			visible: props.settings.editingMode !== 'none' && props.settings.disallowDeleting !== true,
			onItemClick: () => {
				gridComponent.value.instance.deleteRow(e.row.rowIndex);
			}
		},
		{
			text: "View Details",
			icon: "search",
			visible: !!props.settings.showMasterDetail,
			onItemClick: () => {
				gridComponent.value.instance.expandRow(e.row.key);
			}
		}
	);
};

// Deal with a single click from a row in the datagrid (only when useSimpleClickSingle is enabled).
const onRowClick = async (e) => {
	// Only handle if single click mode is specifically enabled
	if (!props.settings.useSimpleClick || !props.settings.useSimpleClickSingle || props.settings.simpleClickMode !== 'page' || !props.settings.simpleClickPage) {
		return;
	}

	// Don't navigate if clicking on edit buttons or other interactive elements
	if (e.event && e.event.target) {
		const target = e.event.target;
		if (target.closest('.dx-command-edit') || target.closest('a') || target.closest('button')) {
			return;
		}
	}

	await navigateToConfiguredPage(e.data);
}

// Shared navigation function for row click actions - navigates to the configured page with optional row context.
const navigateToConfiguredPage = async (rowData) => {
	const targetPageId = props.settings.simpleClickPage;

	try {
		// Fetch the page details to get its path
		const response = await $http.get(`/page/${targetPageId}`);
		const pageData = response.data;
		
		if (!pageData || !pageData.slug) {
			throw new Error('Invalid page data received');
		}

		// Build the navigation path - we need group slug + page slug
		// The page data should include group info, or we can construct from group_id
		let navPath = '';
		if (pageData.group_slug) {
			navPath = `/${pageData.group_slug}/${pageData.slug}`;
		} else if (pageData.group_id) {
			// Fallback: try to get group from cache
			const GroupCache = (await import('@/groups')).default;
			await GroupCache.waitForData();
			const group = GroupCache.getById(pageData.group_id);
			if (group && group.slug) {
				navPath = `/${group.slug}/${pageData.slug}`;
			}
		}

		if (!navPath) {
			throw new Error('Could not determine page path');
		}

		// Navigate to the page, passing the clicked row ID as context if available
		if (rowData && rowData.id) {
			router.push(`${navPath}/${rowData.id}`);
		} else {
			router.push(navPath);
		}
	} catch (error) {
		console.error("Error navigating to page on row click:", error);
		dxAlert("Could not navigate to the configured page: " + (error.message || 'Unknown error'), "Navigation Error");
	}
}

// Deal with a double click from a row in the datagrid.
const onRowDblClick = async (e) => {
	// Check if simple click mode is enabled and configured for page navigation
	if (!props.settings.useSimpleClick || props.settings.simpleClickMode !== 'page' || !props.settings.simpleClickPage) {
		console.log("Row double clicked, but no action configured:", e);
		return;
	}

	// If single click mode is enabled, this handler shouldn't fire (handled by row-click instead)
	if (props.settings.useSimpleClickSingle) {
		return;
	}

	await navigateToConfiguredPage(e.data);
}

// Deal with file uploads setting appropriate return values for our field data.
const onFileUploaded = (data, { request }) => {
	let jsonResponse = JSON.parse(request.response);
	if (jsonResponse.id) {
		data.setValue(stripFileFieldData(jsonResponse));
	}
}
// Deal with file value changes that are not uploads - in this case, only handling removal of files.
const onFileValueChanged = (data, { value, previousValue }) => {
	if (value.length == 0 && previousValue.length > 0) {
		data.setValue(null);
	}
}

// Deal with reference editor value updates from selections / deselections.
const onReferenceValueChanged = (data, event) => {
	console.log("Reference editor updated = ", data, event);
	data.setValue(event);
}

// Deal with a click from a reference link in a datagrid cell.
const onReferenceClicked = (item) => {
	// Query API to determine best way to display this item.
	$http.get(`/mote/${item.id}/viewport?from_group=${props.context.group_id}`).then(response => {
		console.log("Viewport for reference = ", response.data);
		router.push({
			path: response.data.path.startsWith('/') ? response.data.path : `/${response.data.path}`,
			query: { open: item.id, schema: item.type_id },
		});
	}).catch(error => {
		console.error("Error getting viewport for reference:", error);
		if (error.response && error.response.data && error.response.data.message) {
			dxAlert("Error getting viewport for reference: "+ error.response.data.message, "Unable to display reference");
		} else {
			dxAlert("Error getting viewport for reference: " + error.message, "Unable to display reference");
		}
	});
}

// Import button options and binding, show imports button.
const showImportWizard = ref(false);
const importButtonOptions = ref({
	icon: "import",
	hint: "Import",
	onClick: () => {
		if (props.preview) {
			dxAlert("Import is not available in preview mode. Normally, an import wizard would pop up here.", "Import not available");
		} else if (!props.settings.disallowImport) {
			showImportWizard.value = true;
		}
	}
});
const onImportCompleted = (e) => {
	console.log("Import completed", e);
	showImportWizard.value = false;
}
const viewImportsButtonOptions = computed(() => ({
	icon: "importselected",
	type: showImportDataItems.value ? "danger" : "",
	stylingMode: showImportDataItems.value ? "outlined" : "contained",
	hint: showImportDataItems.value ? "Showing also imported rows" : "Not showing imported rows",
	onClick: () => {
		showImportDataItems.value = !showImportDataItems.value;
		// Force a refresh of the data source.
		dataItemsSource.reload();
	},
	visible: !props.settings.disallowImport,
}));

watch(props, async () => {
	// Initialize our columns as defaulting from the schema, with any overrides from the column settings.
	dataColumns.value.length = 0;
	await SchemaCache.waitForData();
	const columnDefaults = props.settings && props.settings.columns ? props.settings.columns : {};
	const rootSchema = props.settings && props.settings.source ? SchemaCache.getSchemaByType(props.settings.source) : null;
	const isRowEditor = props.settings && props.settings.editingMode == 'row';
	
	dataColumns.value = getDatagridColumnsFromSchema(rootSchema, columnDefaults, isRowEditor, 0);
	console.log('Datagrid: Initialized columns', dataColumns.value);

	dataItemsSource.filter(null);
	if (props.settings && props.settings.filter) {
		dataItemsSource.filter(props.settings.filter);
	}

	dataItemsSource.load();
	// Datagrids need a manual refresh as well, it seems.
	if (gridComponent.value)
		gridComponent.value.instance.refresh();

	// If we have a query parameter open, highlight the row with that id if we use a matching schema.
	// Because mote IDs are unique, we don't need to check the schema of the mote itself.
	if (route.query && route.query.open && route.query.schema) {
		if (rootSchema.id == route.query.schema) {
			try {
				let lookupMote = await gridComponent.value.instance.byKey(route.query.open)
				if (lookupMote) {
					gridComponent.value.instance.navigateToRow(route.query.open);
					gridComponent.value.instance.selectRows(route.query.open, false);
				}
			} catch (ex) {
				console.error(`Error looking up mote ${route.query.open} in datagrid, aborting:`, ex);
			}
		}
	}
}, {
	immediate: true
});

</script>

<style>
.master-detail-tabpanel-item {
	display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 12px 0;
}
.dx-datagrid .dx-row.dx-master-detail-row {
	border-bottom: 5px double #363640
}
.dx-row.dx-data-row:has(+ .dx-row.dx-master-detail-row) {
	background-color: #ffefd5;
}
.dx-row.dx-data-row:has(+ .dx-row.dx-master-detail-row.dx-state-invisible) {
	background-color: inherit;
}
.dx-row.dx-master-detail-row:not(.dx-state-invisible) ~ .dx-row.dx-data-row {
    opacity: 0.5;
}
.datagrid-editor-group {
	overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .12), 0 1px 2px rgba(0, 0, 0, .24);
    border-radius: 4px;
    background-color: #fff;
    margin: 2px 2px 3px;
    padding: 10px;
    border-left: 10px solid #ccc;
}
.reference-link {
	margin-right: 5px;
}
.datagrid-use-pointer .dx-datagrid-rowsview .dx-data-row {
	cursor: pointer;
}
.dx-datagrid .dx-row.dx-data-row.dx-row-imported {
	background-color: rgba(255, 0, 0, 0.06);
}
.dx-datagrid .dx-row.dx-data-row.dx-row-imported.dx-row-alt > td {
	background-color: rgba(255, 0, 0, 0.06);
}
</style>
